export default "__VITE_ASSET__5Nf177yE__"